<template>
     <view-data-renderer v-if="content" :viewData="content ?? null"></view-data-renderer>
</template>

<script lang="ts">

import ViewDataRenderer from '../ViewDataRenderer.vue';

export default {

    name: 'ViewRenderer',

    components: {
        'view-data-renderer': ViewDataRenderer,
    },

    props: ['reference'],

    data() {
        return {
            content: this.$slots.default,
        }
    },

    mounted() {
        this.Bus.on('filters-start-loading', () => {
            this.Bus.emit('start-loading', 'view-renderer');
        });

        this.Bus.on('render-view', (data) => {
            if (data.reference === this.reference) {
                const target = document.querySelector(`[data-view-target="${this.reference}"]`);
                if (target) {
                    target.remove();
                }

                this.content = data.content;

                this.Bus.emit('stop-loading', 'view-renderer');
            }
        });
    },

};
</script>
